import { Directive, EventEmitter, Input, Output } from '@angular/core';

/** Shared action-bar state and handlers for the gate input components. */
@Directive()
export abstract class AiChatGateActionsBase {
  @Input() reviewAndSearchLabel = 'Review & Search';
  @Input() refineLabel = 'Help me refine this';
  @Input() continueLabel = 'Continue';
  @Input() showBackAction = false;
  @Input() showSecondaryActions = true;
  @Input() reviewAndSearchDisabled = false;
  @Input() refineDisabled = false;

  @Output() reviewAndSearch = new EventEmitter<void>();
  @Output() refine = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  submitReviewAndSearch(): void {
    if (this.isReviewAndSearchDisabled()) {
      return;
    }
    this.stopVoiceDictation();
    this.reviewAndSearch.emit();
  }

  submitRefine(): void {
    if (this.isRefineDisabled()) {
      return;
    }
    this.stopVoiceDictation();
    this.refine.emit();
  }

  submitBack(): void {
    this.stopVoiceDictation();
    this.back.emit();
  }

  isReviewAndSearchDisabled(): boolean {
    return this.reviewAndSearchDisabled || this.hasAnyValue();
  }

  isRefineDisabled(): boolean {
    return this.refineDisabled || this.hasAnyValue();
  }

  protected abstract hasAnyValue(): boolean;

  protected abstract stopVoiceDictation(): void;
}
